import { IAppConfigurationProvider } from "../../gyzmo-commons/interfaces/IAppConfigurationProvider";

export abstract class IAppConfigurationProviderSpecific extends IAppConfigurationProvider {
    abstract navigateAfterConnectionWithForceRefresh(): Promise<boolean>;
}
